import { NgStyle } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractTailoredTemplateWidget } from '../AbstractTailoredWidgetTemplate.class';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./template-widget-section-title.scss'],
    selector: 'template-widget-section-title',
    templateUrl: 'template-widget-section-title.html',
    imports: [NgStyle]
})
export class TemplateWidgetSectionTitleComponent extends AbstractTailoredTemplateWidget<{ value: string; backgroundColor: string }> {}
